var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title-container"},[_c('h1',{staticClass:"title2"},[_vm._v("\n\t\t\t\tVotre enfant "),_c('nobr',[_vm._v("respire-t-il")]),_c('br'),_vm._v(" un air trop pollué ?\n\t  \t\t")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }